module.exports = __webpack_public_path__ + "static/media/DSC04065.d095cf38.jpg";